import { useMemo } from 'react';
import { calculateElapsedTimeInMinutes } from '@helpers/date';
import { formatElapsedTime } from '@helpers/format';
import { isOnline } from '@helpers/member';
import { AppFCC, SEX } from '@types';
import { OnlineStatusLabelStyled } from '@kit/online-status-label/styled';
import { OnlineStatusLabelProps } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const OnlineStatusLabel: AppFCC<OnlineStatusLabelProps> = props => {
  const {
    className,
    lastVisitTime,
    sex,
    onlineStatus
  } = props;
  const _isOnline = isOnline(onlineStatus);
  const isFemale = sex === SEX.FEMALE;
  const status = useMemo(() => {
    if (_isOnline) {
      return 'Онлайн';
    }
    if (!lastVisitTime) {
      return '';
    }
    const elapsedTime = calculateElapsedTimeInMinutes(lastVisitTime);
    const formattedElapsedTime = formatElapsedTime(elapsedTime || 1);
    return `${isFemale ? 'Была' : 'Был'} в сети ${formattedElapsedTime} назад`;
  }, [_isOnline, isFemale, lastVisitTime]);
  return _jsx(OnlineStatusLabelStyled, {
    className: className,
    children: status
  });
};